package meineglasfaser.api

import kotlinx.serialization.Serializable
import meineglasfaser.api.ubl.UBLAmount
import meineglasfaser.api.ubl.UBLTaxCategory

enum class ProductState {
    DRAFT,
    ACTIVE,
    ARCHIVED;
}

@Serializable
data class Product(
    val id: String,
    val nid: Int,
    val state: ProductState,
    val title: String,
    val summary: String,
    val details: String,
    val audience: List<CustomerType>,
    val maxQuantity: Int,
    val monthlyPrice: UBLAmount,
    val monthlyTaxCategory: UBLTaxCategory,
    val yearlyPrice: UBLAmount,
    val yearlyTaxCategory: UBLTaxCategory,
    val oncePrice: UBLAmount,
    val onceTaxCategory: UBLTaxCategory,
)

@Serializable
data class ProductAdmin(
    val id: String? = null,
    val nid: Int? = null,
    val orderPos: Int,
    val state: ProductState,
    val title: String,
    val summary: String,
    val details: String,
    val audience: List<String>,
    val maxQuantity: Int,
    val monthlyPrice: UBLAmount,
    val monthlyTaxCategoryId: String,
    val yearlyPrice: UBLAmount,
    val yearlyTaxCategoryId: String,
    val oncePrice: UBLAmount,
    val onceTaxCategoryId: String,
    val assignedTo: List<Pair<String, String?>>? = null,
)

fun Product.priceWithTax(customerType: CustomerType): ShopPriceGroup {
    val includeTax = customerType == CustomerType.INDIVIDUAL
    return ShopPriceGroup(
        monthly = if (includeTax) { monthlyPrice.withTax(monthlyTaxCategory) } else { monthlyPrice },
        yearly = if (includeTax) { yearlyPrice.withTax(yearlyTaxCategory) } else { yearlyPrice },
        once = if (includeTax) { oncePrice.withTax(onceTaxCategory) } else { oncePrice },
    )
}
